export const all_routes = {
  dashboard: "/dashboard",
  adminDashboard: "/admin/dashboard",
  contactDetails: "/crm/customer-details",
  deals: "/crm/deals",
  dealsDetails: "/crm/deals-details",
  dealsKanban: "/crm/deals-kanban",
  contactList: "/crm/customer-list",
  leadsKanban: "/leads-kanban",
  pipeline: "/crm/pipeline",
  shareProfile: "/shareProfile",
  userVerification: "/user-verification",
  registrationForm: "/registration-form",

  contactGrid: "/crm/customer-kanban",
  resetPassword: "/email/reset-password",
  forgotPassword: "/forgotPassword/:method",
  phoneResetPassword: "/phone-reset-password",
  manageQuotes: "/admin/manage-quotes",
  pushNotifications: "/admin/push-notifications",
  emailNotifications: "/admin/email-notifications",
  californiaEmailNotifications: "/admin/california-email-notifications",
  invoiceCustomization: "/admin/invoice-customization",

  contactsDetails: "/contacts-details",
  adminUserDetails: "/admin/user-details",
  leads: "/leads",
  contacts: "/contacts",
  templates: "/templates",
  // whatsappTemplates: "/templates#whatsappTemplates",
  // emailTemplates: "/templates#emailTemplates",
  emails: "/emails",
  calendar: "/calendar",
  adminCalendar: "/admin/calendar",
  Whatsapp: "/crm/Whatsapp",
  login: "/login",
  register: "/register",
  upgradePlan: "/general-settings/upgrade-plan",
  biilingInfo: "/general-settings/billing-info",
  invoiceView: "/general-settings/invoice/:invoiceId",
  managePlans: "/admin/manage-plans",

  scans: "/general-settings/scans",
  profile: "/general-settings/profile",
  adminProfile: "/admin/general-settings/profile",
  security: "/general-settings/security",
  adminSecurity: "/admin/general-settings/security",
  emailSetup: "/general-settings/emailSetup",
  ImportAndExport: "/import-and-export",
  Api: "/api",
  AdminApi: "/admin/api",
  SyncAndIntegration: "/sync-and-integration",
  HelpAndSupport: "/help-and-support",
  adminHelpAndSupport: "/admin/help-and-support",
  myTickets: "/my-tickets",
  users: "/admin/users",
  Zapier: "/zapier",
  contactReports: "/reports/contact-reports",
  ReferAndEarn: "/refer-and-earn",
  groups: "/groups",
  manageTickets: "/admin/manage-tickets",
  manageCoupons: "/admin/manage-coupons",
  paymentSuccess: "/payment-success",
  paymentUnsuccessful: "/payment-unsuccessful",
  embeddedCheckout: "/embedded-checkout",
};
